import React, { useState, useRef, useEffect } from 'react';
import { FormControl, Select, InputLabel, TableHead, Link, MenuItem, Paper, Popover, Stack, Table, TableBody, TableCell, TableContainer, TextField, TableRow, Typography, Card, CardContent, FormHelperText, Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import { ADD_FINANCIAL_YEAR, GET_FINANCIAL_YEAR } from '../../common/URLs';
import { loaderService } from '../../common/custom-loader/loader-service';

import { toast } from 'react-toastify';
import { getLocalStorageItem } from '../../common/localStorageUtils';
import apiClient from '../../axios';

export const FinancialYearDropdown = (props) => {
  const [financialYear, setFinancialYear] = useState(props.selectedYear ? props.selectedYear : 'select');
  const [financialYearList, setFinancialYearList] = useState([]);
  const uuid = localStorage.getItem('uuid');
  const handleFinancialYearChange = (event) => {
    const dataToBePassed = event.target.value;
    setFinancialYear(dataToBePassed);
    props.selectedValue(dataToBePassed);
  };

  const onAddNewYearClick = (e) => {
    addFinancialYear();
  }

  useEffect(() => {
    getFinancialYearApi();
  }, []);


  const compareSecondColumn = (a, b) => {
    if (a < b)  return -1;
    else if (a > b)  return 1;
    else return 0
}


      // -----------------API Calls-------------------

      const getFinancialYearApi = () => {
        loaderService.showLoader();
        apiClient.post(GET_FINANCIAL_YEAR,
            null,
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
              let data = response.data?.financialYearLst
              data.sort(compareSecondColumn);
              setFinancialYearList(response.data?.financialYearLst)
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    
    const addFinancialYear = () => {
      loaderService.showLoader();
      apiClient.post(ADD_FINANCIAL_YEAR + `?userId=${uuid}`,
          null,
          {
              headers: {
                  Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                  "Content-Type": "application/json"
              }
          })
          .then((response) => {
              toast.success(response.message);
              getFinancialYearApi();
              loaderService.hideLoader();

          }).catch(function (error) {
              loaderService.hideLoader();
              toast.error(error.message);
          });
  }

  return (
    <FormControl sx={{ width: '100%' }} size="small">
      <InputLabel id="demo-simple-select-helper-label">Financial Year</InputLabel>
      <Select
        labelId="demo-simple-select-helper-label"
        id="demo-simple-select-helper"
        value={financialYear}
        label="Financial Year"
        onChange={handleFinancialYearChange}
        disabled={props.isDisabled}
      >
        <MenuItem value={'select'} disabled>---Select---</MenuItem>
        {financialYearList?.map((item) => 
          <MenuItem value={item}>{item}</MenuItem>

        )}
        <MenuItem value=''><Button endIcon={<AddIcon />} onClick={(e) => onAddNewYearClick(e)}>Add New</Button></MenuItem>
      </Select>
      <FormHelperText style={{color: 'red', fontSize: 10}}>{props.helperText}</FormHelperText>
    </FormControl>
  )
}